import { gql } from '@apollo/client';
import { lazyQueryFactory } from '../../../utils/gqlFactories';

const customerDetailQuery = gql`
    query customerDetail($id: Int!) {
        customerDetail(id: $id) {
            id
            customer {
                id
                email
            }
            firstname
            lastname
            phone
            created_at
        }
    }
`;

interface CustomerDetail {
    id: number;
    customer: { id: number; email: string };
    firstname: string;
    lastname: string;
    phone: string;
    created_at: string;
}

const useCustomerDetailLazyQuery = lazyQueryFactory<CustomerDetail>(customerDetailQuery, 'customerDetail');

export type { CustomerDetail };
export default useCustomerDetailLazyQuery;
